let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eCWuG")).then(() => parcelRequire('dK43S'));